import React, { useCallback, useState } from "react";
// import {  } from "react-router-dom";
import { Alert } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import useAxiosInterceptors from "../../../../hooks/httpConfig";
// import { Redirect } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { ModalContent } from "../../../components";
const sendOTDSchema = Yup.object().shape({
  email: Yup.string()
    .email("Email invalide")
    .required("L'adresse e-mail est obligatoire"),
});
/*--Mounir--*/
// ancien code
// const resetSchema = Yup.object().shape({
//   otd: Yup.number()
//     .positive()
//     .integer()
//     .required("Le code OTD est obligatoire!"),
//   password: Yup.string()
//     .min(8, "Le mot de passe doit contenir au moins 8 caracteres!")
//     .required("Mot de passe obligatoire!"),
// });

//NOuveau code
const resetSchema = Yup.object().shape({
  otp: Yup.number()
    .positive()
    .integer()
    .required("Le code OTP est obligatoire!"),
  password: Yup.string()
    .min(8, "Le mot de passe doit contenir au moins 8 caracteres!")
    .required("Mot de passe obligatoire!"),
  confirmPassword: Yup.string()
    .oneOf(
      [Yup.ref("password"), null],
      "Les mots de passe ne correspondent pas!",
    )
    .required("Veuillez confirmer votre mot de passe!"),
});
/*----*/

const ForgotPasswordForm = () => {
  const axiosInstance = useAxiosInterceptors();
  // const [mailSent, setMailSent] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [emailAlert, setEmailAlert] = useState(null);
  const [otpAlert, setOtpAlert] = useState(null);
  const history = useHistory();
  const formikSendMail = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: sendOTDSchema,
    onSubmit: (values) => {
      axiosInstance
        .post(`sendResetPasswordEmail`, values)
        .then((response) => {
          if (response.data.success) {
            handleShowModal();
          }
        })
        .catch((e) => {
          setEmailAlert({
            message: e.response?.data?.message || "Une erreur est survenue.",
            variant: "danger",
          });
        });
    },
  });

  /*--Mounir--*/
  // ancien code
  // const formikSendOtd = useFormik({
  //   initialValues: { otd: "" },
  //   onSubmit: (values) => {
  //     axiosInstance.patch(`resetPassword`, { email, otd: values.otd })
  //   },
  // });

  //Nouveau code
  const formikSendOtd = useFormik({
    initialValues: {
      otp: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: resetSchema,
    onSubmit: (values) => {
      axiosInstance
        .patch(`resetPassword`, {
          email: formikSendMail.values.email,
          otp: values.otp,
          newPassword: values.password,
        })
        .then((response) => {
          if (response.data.success) {
            history.push("/login");
          }
        })
        .catch((e) => {
          setOtpAlert({
            message: e.response?.data?.message || "Une erreur est survenue.",
            variant: "danger",
          });
        });
    },
  });
  /*----*/

  const handleCloseModal = useCallback(() => {
    setShowConfirmModal(false);
    setOtpAlert(null);
    formikSendOtd.resetForm();
  }, []);

  // const handleConfirm = useCallback(() => {
  //   setShowConfirmModal(true)
  // }, [])

  const handleShowModal = useCallback(() => {
    setShowConfirmModal(true);
  }, []);

  // useEffect(() => {
  //   setShowConfirmModal(true)
  // }, [])

  return (
    <>
      {/* LOGIN TITLE */}
      {/* {!mailSent ? (
        <>
          <h3 className="LoginForm-Title">Reinitialisation !</h3>
          <form
            id="LoginForm"
            className="LoginForm"
            onSubmit={formikSendOtd.handleSubmit}
          >
            <div className="Input-Row">
              <i className="uil uil-envelope"></i>
              <input
                type="text"
                name="email"
                id="email"
                placeholder="Adresse e-mail"
                className="DRInput-Class"
                onChange={formikSendOtd.handleChange}
                onBlur={formikSendOtd.handleBlur}
                value={formikSendOtd.values.email}
              />
              {formikSendOtd.touched.email && formikSendOtd.errors.email ? (
                <div className="text-danger text-right">
                  {formikSendOtd.errors.email}
                </div>
              ) : null}
            </div>
            <button
              type="submit"
              name="FormLogin-Submit"
              className="Form-Submit"
            >
              <i className="uil uil-user-check"></i> Reinitialiser
            </button>
          </form>
        </>
      ) : (
        <>
          <h3 className="LoginForm-Title">Reinitialisation du mot de passe!</h3>
          <p>
            Priere de saisir le code recu par email ainsi que votre nouveau mot
            de passe!
          </p>
          <form
            id="LoginForm"
            className="LoginForm"
            onSubmit={formikSendMail.handleSubmit}
          >
            <div className="Input-Row">
              <i className="uil uil-envelope"></i>
              <input
                type="text"
                name="otd"
                id="otd"
                placeholder="Code OTD"
                className="DRInput-Class"
                onChange={formikSendMail.handleChange}
                onBlur={formikSendMail.handleBlur}
                value={formikSendMail.values.otd}
              />
              {formikSendMail.touched.otd && formikSendMail.errors.otd ? (
                <div className="text-danger text-right">
                  {formikSendMail.errors.otd}
                </div>
              ) : null}
            </div>
            <div className="Input-Row">
              <i className="uil uil-padlock"></i>
              <input
                type="text"
                name="password"
                id="password"
                placeholder="Nouveau mot de passe"
                className="DRInput-Class mt-6"
                onChange={formikSendMail.handleChange}
                onBlur={formikSendMail.handleBlur}
                value={formikSendMail.values.password}
              />
              {formikSendMail.touched.password && formikSendMail.errors.password ? (
                <div className="text-danger text-right">
                  {formikSendMail.errors.password}
                </div>
              ) : null}
            </div>
            
            <button
              type="submit"
              name="FormLogin-Submit"
              className="Form-Submit"
            >
              <i className="uil uil-check-circle"></i> Valider
            </button>
            {alert && (
              <Alert mt={3} variant={alert.varian}>
                <div className="text-center">{alert.message}</div>
              </Alert>
            )}
          </form>
        </>
      )} */}

      <>
        <h3 className="LoginForm-Title">Reinitialisation !</h3>
        <form
          id="LoginForm"
          className="LoginForm"
          onSubmit={formikSendMail.handleSubmit}
        >
          {/* LOGIN INPUTS */}
          <div className="Input-Row">
            <i className="uil uil-envelope"></i>
            <input
              type="text"
              name="email"
              id="email"
              placeholder="Adresse e-mail"
              className="DRInput-Class"
              onChange={formikSendMail.handleChange}
              onBlur={formikSendMail.handleBlur}
              value={formikSendMail.values.email}
            />
            {formikSendMail.touched.email && formikSendMail.errors.email ? (
              <div className="text-danger text-right">
                {formikSendMail.errors.email}
              </div>
            ) : null}
          </div>
          {/* LOGIN SUBMIT */}
          <button type="submit" name="FormLogin-Submit" className="Form-Submit">
            <i className="uil uil-user-check"></i> Reinitialiser
          </button>
          {emailAlert && (
            <Alert mt={3} variant={emailAlert.variant}>
              <div className="text-center">{emailAlert.message}</div>
            </Alert>
          )}
        </form>
      </>

      <ModalContent
        size="none"
        title={`Vérification du code OTP`}
        show={showConfirmModal}
        onHide={handleCloseModal}
      >
        <p className="text-center">
          Saisissez le code que vous venez de recevoir par email !
        </p>
        {/*--Mounir--*/}
        {/* ancien code */}
        {/* onsubmit={formikSendOtd.handleSubmit} — onsubmit (minuscule) ignoré par React */}
        {/* name="otd" / values.otd — mauvais nom de champ, backend attend otp */}
        {/* newPassword absent du body envoyé */}
        {/* variant={alert.varian} — typo */}

        {/*correction code*/}
        <form
          id="LoginForm"
          className="LoginForm"
          onSubmit={formikSendOtd.handleSubmit}
        >
          <div className="Input-Row">
            <i className="uil uil-lock-alt"></i>
            <input
              type="text"
              name="otp"
              id="otp"
              placeholder="Code de vérification"
              className="DRInput-Class"
              onChange={formikSendOtd.handleChange}
              onBlur={formikSendOtd.handleBlur}
              value={formikSendOtd.values.otp}
            />
            {formikSendOtd.touched.otp && formikSendOtd.errors.otp ? (
              <div className="text-danger text-right">
                {formikSendOtd.errors.otp}
              </div>
            ) : null}
          </div>

          <div className="Input-Row">
            <i className="uil uil-padlock"></i>
            <input
              type="password"
              name="password"
              id="password"
              placeholder="Nouveau mot de passe"
              className="DRInput-Class"
              onChange={formikSendOtd.handleChange}
              onBlur={formikSendOtd.handleBlur}
              value={formikSendOtd.values.password}
            />
            {formikSendOtd.touched.password && formikSendOtd.errors.password ? (
              <div className="text-danger text-right">
                {formikSendOtd.errors.password}
              </div>
            ) : null}
          </div>

          <div className="Input-Row">
            <i className="uil uil-padlock"></i>
            <input
              type="password"
              name="confirmPassword"
              id="confirmPassword"
              placeholder="Confirmer le mot de passe"
              className="DRInput-Class"
              onChange={formikSendOtd.handleChange}
              onBlur={formikSendOtd.handleBlur}
              value={formikSendOtd.values.confirmPassword}
            />
            {formikSendOtd.touched.confirmPassword &&
            formikSendOtd.errors.confirmPassword ? (
              <div className="text-danger text-right">
                {formikSendOtd.errors.confirmPassword}
              </div>
            ) : null}
          </div>

          <br />
          <div className="Settings-Field Settings-Field-1">
            <div className="row">
              <div className="col-md-12 text-right">
                <button
                  onClick={handleCloseModal}
                  type="button"
                  className="btn Cancel-BTN"
                >
                  Annuler
                </button>
                <button type="submit" className="btn Save-BTN">
                  Valider
                </button>
              </div>
            </div>
          </div>
          {otpAlert && (
            <Alert mt={3} variant={otpAlert.variant}>
              <div className="text-center">{otpAlert.message}</div>
            </Alert>
          )}
        </form>
        {/*----*/}
      </ModalContent>
    </>
  );
};

export default ForgotPasswordForm;
